module.exports = __webpack_public_path__ + "static/media/galerija_2013 (27).d6ba1327.jpg";